import { useCms } from "./useCms";
import { Field, Panel, ListControls, AddButton, moveItem } from "./Fields";

export default function FaqsEditor() {
  const { data, setData, save, saving } = useCms("faqs", []);
  const list = Array.isArray(data) ? data : [];
  const update = (i, patch) => setData(list.map((f, idx) => (idx === i ? { ...f, ...patch } : f)));

  return (
    <Panel title={`FAQs (${list.length})`} description="First 6 show on the homepage; all show on /faq. Pricing page picks FAQs mentioning cost, trial, cancel, upgrade or support." onSave={() => save(list)} saving={saving} saveTestid="faqs-save">
      <div className="space-y-3">
        {list.map((f, i) => (
          <div key={i} data-testid={`faq-row-${i}`} className="rounded-xl border border-slate-200 p-4">
            <div className="flex items-start gap-3">
              <div className="flex-1 space-y-3">
                <Field label={`Question ${i + 1}`} value={f.q} onChange={(v) => update(i, { q: v })} testid={`faq-q-${i}`} />
                <Field label="Answer" multiline value={f.a} onChange={(v) => update(i, { a: v })} testid={`faq-a-${i}`} />
              </div>
              <ListControls index={i} total={list.length} onMove={(a, b) => setData(moveItem(list, a, b))} onRemove={(idx) => setData(list.filter((_, j) => j !== idx))} testid={`faq-delete-${i}`} />
            </div>
          </div>
        ))}
      </div>
      <AddButton label="Add FAQ" testid="faq-add" onClick={() => setData([...list, { q: "", a: "" }])} />
    </Panel>
  );
}
